// import GuideBoard from 'components/GuideBoard/GuideBoard';
import LoadingImage from 'components/LoadingImage';
import MenuTop from 'components/Menu';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPanoData, setTourData } from 'store/actions';
import { loadTourJson } from 'utils/apiHelper';

import './styles.scss';

const tourId = process.env.REACT_APP_TOUR_ID;

export const Layout = ({ children, className = '' }) => {
  const dispatch = useDispatch();
  const [isApiLoaded, setIsApiLoaded] = useState(false);

  useEffect(() => {
    const handleGetTour = async () => {
      const { json, tour } = await loadTourJson(tourId);
      console.log('Loaded tour json:', json, tour);

      dispatch(setPanoData(json));
      dispatch(setTourData(tour));

      setIsApiLoaded(true);
    };

    handleGetTour();
  }, [dispatch]);

  return (
    <>
      <div style={{}} className={`layout ${className}`}>
        <LoadingImage
          isApiLoaded={isApiLoaded}
          onStarted={() => {
            // after 3s from loading start, show guide board behind loading
            // dispatch(setGuideBoardVisible(true));
          }}
        />
        {isApiLoaded && (
          <>
            <div className="layout-menu">
              <MenuTop />
            </div>
            <div
              className="layout-content"
              style={{ display: 'flex', flex: 1, position: 'relative' }}
            >
              {children}
            </div>
          </>
        )}
      </div>

      {/* <GuideBoard /> */}
    </>
  );
};
